import React, { useEffect, useState } from "react";
import { MDBRow, MDBCard, MDBCardBody, MDBCol } from "mdb-react-ui-kit";
import CommonViewLayout from "./CommonViewLayout";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import { decryptData, encryptData } from "../../../Utilities/CryptoUtility";
import Spinner from "../../../Components/Spinner";
import { useTranslation } from "../../../Context/TranslationContext";
import { SecureStorage } from '../../../Utilities/StorageEncryption';

const Home = () => {
  const { makeApiCall } = useAxiosCall();
  const [ spinner, setSpinner ] = useState(false);
  const { translations } = useTranslation();
  const [hasDomain, setHasDomain] = useState(false);

  useEffect(() => {
    async function checkAndHandleDomainVariable() {
      try {
        const domainVar = await checkDomainVariable();
        if (domainVar != '') {
          setHasDomain(true);
          fetchData('getWebActivityCount');
          // fetchData('getRentDueCount');
        } else {
          setHasDomain(false);
        }
      } catch (error) {
        console.error('Error:', error);
        setHasDomain(false);
      }
    }

    checkAndHandleDomainVariable();
  }, [SecureStorage.getItem('domain')]);


  function checkDomainVariable() {
    return new Promise((resolve, reject) => {
      const intervalId = setInterval(() => {
        const domainVariable = SecureStorage.getItem('domain');
        if (domainVariable) {
          clearInterval(intervalId);
          resolve(domainVariable);
        }
      }, 1000); // Check every 1 second
    });
  }
  const [blockData, setBlockLayoutData] = useState({});

  const handleApiCallSuccess = (data, dataKey) => {
    let decryptedData = decryptData(data.data);
    setBlockLayoutData((prevData) => ({
      ...prevData,
      [dataKey]: decryptedData.data.count
    }));
    setSpinner(false);
  };
  const handleApiCallError = (errorMessage) => {
    console.log(errorMessage);
    setSpinner(false);
  };

  const fetchData = async (dataKey) => {
    setSpinner(true);
    setBlockLayoutData({});
    const requestData = {
      data: encryptData(JSON.stringify(
        {
          domain: SecureStorage.getItem('domain')
        }
      ))
    };
    await makeApiCall({
      requestData,
      onSuccess: (data) => handleApiCallSuccess(data, dataKey),
      onError: handleApiCallError,
      requestType: 'POST',
      url: dataKey,
      loader: false
    });
  }

  return (
    <CommonViewLayout
      headerTitle="Home"
      iconName="home"
    >
      {hasDomain && (
        <section>
          <MDBRow>
            <MDBCol lg="12" className="mb-4 mb-lg-0">
              <MDBRow>
                <BlockLayout title={translations['New Web Activity'] != undefined ? translations['New Web Activity'] : 'New Web Activity'} count={blockData.getWebActivityCount} field={blockData.getWebActivityCount} spinner={spinner} />
                {/* <BlockLayout title={translations['Rent Due'] != undefined ? translations['Rent Due'] : 'Rent Due'} count={blockData.getRentDueCount} field={blockData.getRentDueCount} spinner={spinner} /> */}
                {/* <BlockLayout title="Vacant Properties" count="120" field={blockData.vacantProperty} /> */}
              </MDBRow>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol lg="12" className="mb-4 mb-lg-0">
              <MDBRow>
                {/* <BlockLayout title="EFT Payments not sent" count="120" field={blockData.eftPaymentNotSent} />
                <BlockLayout title="Scheduled Payments" count="12" field={blockData.scheduledPayment} /> */}
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </section>
      )}
    </CommonViewLayout>
  );
};

const BlockLayout = ({ title, count, field , spinner }) => {
  return (
    <MDBCol lg="3" className="mb-4">
      <MDBCard className="text-center">
        <MDBCardBody>
          {(field != undefined && spinner == false) ?
            <>
              <p className="mb-2">{title}</p>
              <h6>{count}</h6>
            </> : <Spinner />}
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  )
}

export default Home;
